import axiosInstance from '../../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../../env'
import type { LumpsumAllocationPlansResponse } from './allocation.types'
import type { LumpsumIdealPlansResponse } from './ideal.types'
import type { LumpsumRebalancePlansResponse } from './rebalance.types'

const LUMPSUM_REBALANCE_PLANS_URL = `${mobileBackendUrl}/v2/portfolio/rebalance-plan/lumpsum/summary`
const LUMPSUM_ALLOCATION_PLANS_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/lumpsum/summary`
const LUMPSUM_PLANS_IDEAL_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/ideal`

export async function fetchLumpsumRebalancePlans(): Promise<LumpsumRebalancePlansResponse> {
  const response = await axiosInstance.get<LumpsumRebalancePlansResponse>(LUMPSUM_REBALANCE_PLANS_URL)
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum rebalance plans')
  }
  return response?.data
}

export async function fetchLumpsumAllocationPlans(): Promise<LumpsumAllocationPlansResponse> {
  const response = await axiosInstance.get<LumpsumAllocationPlansResponse>(LUMPSUM_ALLOCATION_PLANS_URL)
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum allocation plans')
  }
  return response?.data
}

export async function fetchLumpsumIdealPlans(): Promise<LumpsumIdealPlansResponse> {
  const response = await axiosInstance.get<LumpsumIdealPlansResponse>(LUMPSUM_PLANS_IDEAL_URL)
  if (!response?.data) {
    throw new Error('Failed to fetch lumpsum ideal plans')
  }
  return response?.data
}
